import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { getVendorRestrictionsById } from '../../modules/products/actions';
import DeliveryDateSelector from './DeliveryDateSelector';
import styles from './DeliveryDateSelector.styles';

const mapStateToProps = ({ productsModule: { productRestrictions } }) => ({
  restrictionsMap: productRestrictions.restrictionsMap,
});

const mapDispatchToProps = {
  getVendorRestrictionsById,
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(DeliveryDateSelector);
